import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import gsap from 'gsap';
import Btn from '../components/common/btn.jsx';
import './Onboarding.css';
import './genarel.css';


const Onboarding3 = () => {
    const squareOuterRef = useRef(null);
    const squareInnerRef = useRef(null);
    const archRef = useRef(null);
    const iconRef = useRef(null);
    const titleRef = useRef(null);
    const paraRef = useRef(null);
    const dotsRef = useRef(null);
    const btnRef = useRef(null);

    useEffect(() => {
        const tl = gsap.timeline({ defaults: { ease: 'expo.out' } });

        gsap.set(squareOuterRef.current, { opacity: 0, rotation: 25, scale: 0.4 });
        gsap.set(squareInnerRef.current, { opacity: 0, rotation: -20, scale: 0.4 });
        gsap.set(archRef.current, { opacity: 0, y: 80, rotation: -6 });
        gsap.set(iconRef.current, { opacity: 0, scale: 2, rotation: 45 });
        gsap.set(titleRef.current, { opacity: 0, x: 50 });
        gsap.set(paraRef.current, { opacity: 0, y: 25 });
        gsap.set(dotsRef.current, { opacity: 0, scale: 0.5 });
        gsap.set(btnRef.current, { opacity: 0, y: 40 });

        tl.to(squareOuterRef.current, { opacity: 1, rotation: 8, scale: 1, duration: 0.9 })
          .to(squareInnerRef.current, { opacity: 1, rotation: -5, scale: 1, duration: 0.75 }, '-=0.6')
          .to(archRef.current, { opacity: 1, y: 0, rotation: 0, duration: 0.7 }, '-=0.45')
          .to(iconRef.current, { opacity: 1, scale: 1, rotation: 0, duration: 0.6 }, '-=0.35')
          .to(titleRef.current, { opacity: 1, x: 0, duration: 0.65 }, '-=0.25')
          .to(paraRef.current, { opacity: 1, y: 0, duration: 0.5 }, '-=0.3')
          .to(dotsRef.current, { opacity: 1, scale: 1, duration: 0.4 }, '-=0.2')
          .to(btnRef.current, { opacity: 1, y: 0, duration: 0.5 }, '-=0.2');
    }, []);

    return (
        <div className="ob-wrapper">
            <div className="mobile-container">
                <main className="ob-screen">

                    <div className="ob-visual-area" aria-hidden="true">
                        <div className="ob-square-outer" ref={squareOuterRef}></div>
                        <div className="ob-square-dashed" ref={squareInnerRef}></div>
                        <div className="ob-arch" ref={archRef}>
                            <span className="ob-icon" ref={iconRef}>
                                <svg width="92" height="92" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2z"/>
                                    <path d="M13 5v2M13 17v2M13 11v2"/>
                                </svg>
                            </span>
                        </div>
                    </div>

                    <div className="ob-body">
                        <h1 className="ob-title" ref={titleRef}>Your Digital Ticket Hub</h1>
                        <p className="ob-para" ref={paraRef}>Store all your tickets in one place. Quick access with QR codes for seamless entry.</p>
                    </div>

                    <div className="ob-dots" ref={dotsRef} role="img" aria-label="Step 3 of 3">
                        <span className="ob-dot" aria-hidden="true"></span>
                        <span className="ob-dot" aria-hidden="true"></span>
                        <span className="ob-dot ob-dot--active" aria-hidden="true"></span>
                    </div>

                    <div className="ob-btn-wrap" ref={btnRef}>
                        <Link to="/home" className="ob-link" aria-label="Finish onboarding and go to home page">
                            <Btn btnt="GET STARTED" />
                        </Link>
                    </div>

                </main>
            </div>
        </div>
    );
};

export default Onboarding3;